module.exports = __webpack_public_path__ + "static/media/competitions.f1220854.jpg";